import request from '@/util/http'
import { queryByFileId } from '@/api/upload'
import { saveAs } from 'file-saver'

export const download = (id) => {
  if (id && typeof id === 'string' && /(http|https)\:\/\//.test(id)) {
    return saveAs(id)
  }
  return queryByFileId({
    fileId: id,
  })
    .then((v) => {
      return request({
        url: '/zcjf/base/file/download/' + id,
        method: 'get',
        responseType: 'blob',
      })
        .then((response) => {
          if(v.data){
            saveAs(response.data, v.data.fileName)
          }
        })
        .catch((e) => {
          console.warn(e)
        })
    })
    .catch((e) => {
      console.warn(e)
    })
}


export const download1 = (id) => {
  if (id && typeof id === 'string' && /(http|https)\:\/\//.test(id)) {
    return window.open(id)
  }
  return queryByFileId({
    fileId: id,
  })
    .then((v) => {
      return request({
        url: '/zcjf/base/file/download/' + id,
        method: 'get',
        responseType: 'blob',
      })
        .then((response) => {
          if(v.data){
          saveAs(response.data, v.data.fileName)
          }
        })
        .catch((e) => {
          console.warn(e)
        })
    })
    .catch((e) => {
      console.warn(e)
    })
}

export const download3 = (id, fileName) => {
  if (id && typeof id === 'string' && /(http|https)\:\/\//.test(id)) {
    return saveAs(id, fileName)
  }
  return queryByFileId({
    fileId: id,
  })
    .then((v) => {
      return request({
        url: '/zcjf/base/file/download/' + id,
        method: 'get',
        responseType: 'blob',
      })
        .then((response) => {
          if(v.data){
            saveAs(response.data, fileName)
          }
        })
        .catch((e) => {
          console.warn(e)
        })
    })
    .catch((e) => {
      console.warn(e)
    })
}


export const downloadUrl = (params, fileName) => {
  return request({
    url: '/zcjf/base/file/urlDownload',
    method: 'get',
    responseType: 'blob',
    params,
  })
    .then((response) => {
      saveAs(response.data, fileName)
    })
    .catch((e) => {
      console.warn(e)
    })
}